import ProjectCreateForm from '../modules/forms/projects/create';
import JobCreateForm from '../modules/forms/jobs/create';

import PhotoUpload from '../modules/components/projects/photo-upload';
import JobPhotoUpload from '../modules/components/jobs/photo-upload';

export default function setCreationScripts () {
    if (!window.location.pathname.includes('/create-')) return;

    const path = window.location.pathname;

    const routes = {
        project: () => path === '/create-project/',
        job: () => path === '/create-job/',
    };

    if (routes.project()) {
        new ProjectCreateForm('#project-creation-form');

        PhotoUpload();
    }

    if (routes.job()) {
        new JobCreateForm('#job-creation-form');

        JobPhotoUpload();
    }
}
